import React, { useState } from 'react';
import hamburgerImg from "./hamburger.png"; // Ensure the image is imported with the correct path
import './Hamburger.css'; // Import the CSS file for the Hamburger component

const Hamburger = () => {
  const [userAddress, setUserAddress] = useState('');

  const connectWalletHandler = async () => {
    if (window.ethereum) {
      try {
        const newAccounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        setUserAddress(newAccounts[0]);
        // You might want to do something with the userAddress here or elsewhere
      } catch (error) {
        console.error("Error connecting to MetaMask", error);
      }
    } else {
      alert("Please install MetaMask to connect your wallet.");
    }
  };

  return (
    <img src={hamburgerImg} alt="Menu" className="hamburger-icon" onClick={connectWalletHandler} />
  );
};

export default Hamburger;
